import { getConfig } from "src/apiConfig";
import { deleteRequest, get, put, post } from "src/common/apiClient";
import { IMPERSONATION, IMPERSONATION_ID, handleErrors } from "src/common";
import { USE_COOKIE_AUTH } from "src/common/Auth/auth0-variables";
const url = getConfig(IMPERSONATION).url;

const getImpersonationId = () => {
  return sessionStorage.getItem(IMPERSONATION_ID);
};

export const impersonateUser = (emailString) => {
  const email = encodeURIComponent(emailString);
  if (USE_COOKIE_AUTH) return impersonateUserCookie(email);
  else return impersonateUserJWT(email);
};

const impersonateUserCookie = (email) => {
  return post({ url: `/auth/impersonate?email=${email}` })
    .then(handleErrors)
    .then((res) => res.json())
    .then((res) => {
      return {
        id: res.account_id,
      };
    });
};

const impersonateUserJWT = (emailString) => {
  if (url) {
    return post({ url: `${url}/User?email=${emailString}` })
      .then(handleErrors)
      .then((res) => res.json())
      .then((res) => {
        return {
          token: res.auth0TokenResponse.access_token,
          id: res.impersonationHeaderId,
        };
      });
  } else {
    return Promise.reject(new Error(`Missing ${IMPERSONATION} url`));
  }
};

export const isImpersonated = () => {
  if (url) {
    return get({ url: `${url}/IsSessionActive` })
      .then(handleErrors)
      .then((res) => res.json());
  } else {
    return Promise.reject(new Error(`Missing ${IMPERSONATION} url`));
  }
};

export const logoutImpersonation = () => {
  if (USE_COOKIE_AUTH) return logoutImpersonationCookie();
  else return logoutImpersonationJWT();
};

const logoutImpersonationJWT = () => {
  const id = getImpersonationId();
  if (url) {
    return put({ url: `${url}/CloseSession/${id}`, keepAlive: true });
  } else {
    return Promise.reject(new Error(`Missing ${IMPERSONATION} url`));
  }
};

const logoutImpersonationCookie = () => {
  const id = getImpersonationId();
  return deleteRequest({ url: `/auth/impersonate/${id}`, keepAlive: true });
};
